/** PRJ-01 immutable project ticket key, e.g. APP. */
export const PROJECT_KEY_PATTERN = /^[A-Z][A-Z0-9]{1,9}$/;
export const ticketKey = (projectKey: string, number: number) => `${projectKey}-${number}`;
export function parseTicketKey(key: string): { projectKey: string; number: number } | null {
  const m = /^([A-Z][A-Z0-9]{1,9})-(\d+)$/.exec(key.trim());
  return m ? { projectKey: m[1]!, number: Number(m[2]) } : null;
}

/** PRJ-07: repository URLs must not embed credentials. */
export function repositoryUrlProblem(url: string): string | null {
  const trimmed = url.trim();
  if (/^[\w.-]+@[\w.-]+:[\w./-]+$/.test(trimmed)) return null; // scp-like git@host:org/repo.git
  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return 'Enter a valid repository URL.';
  }
  if (!['https:', 'ssh:', 'git:', 'http:'].includes(parsed.protocol)) return 'Use an https, ssh, or git URL.';
  if (parsed.password || (parsed.username && parsed.protocol !== 'ssh:')) {
    return 'Repository URLs must not contain credentials.';
  }
  if (parsed.search && /token|key|secret|password/i.test(parsed.search))
    return 'Repository URLs must not contain credentials.';
  return null;
}

export const isAbsolutePath = (p: string) => /^(\/|[A-Za-z]:[\\/])/.test(p.trim());
